import { Stack } from '@mui/system';

import { IntegrationClientModel } from '@client-app-sdk/api/v1';
import { Avatar, AvatarGroup, styled, Tooltip, Typography } from '@mui/material';
import MoreTexts from './MoreTexts';

export const IntegrationAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(3),
  height: theme.spacing(3),
  backgroundColor: theme.palette.background.active,
}));

export default function IntegrationsCell({
  integrations,
  bundleName,
}: {
  integrations: IntegrationClientModel[];
  bundleName?: string;
}) {
  return (
    <Stack direction="row" justifyContent="flex-start" spacing={1}>
      <AvatarGroup
        max={2}
        slotProps={{
          additionalAvatar: {
            sx: {
              width: '24px',
              height: '24px',
              fontSize: '0.75rem',
              color: 'text.secondary',
            },
          },
        }}
      >
        {integrations.map((integration) => (
          <Tooltip key={integration.id} title={integration.name} arrow placement="top">
            <IntegrationAvatar key={integration.id} alt={integration.name} src={integration.icons.svg} />
          </Tooltip>
        ))}
      </AvatarGroup>
      <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0.5}>
        <MoreTexts texts={integrations.map((integration) => integration.name)} />
        {bundleName && (
          <Typography variant="helperText" color="text.muted">
            <strong>Bundle:</strong> {`${bundleName}`}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
